


export function hasConfig(config) {
    let sw = config.filter(rowConf => rowConf.code === 'INTERMEDIATE').length > 0
    return (
        sw
    )
}
